import { featureToastKey, ToastState } from './toast.reducer';
import { createSelector } from '@ngrx/store';
import { ToastModel } from '@syncfusion/ej2-angular-notifications';

export const getToastsState = (state: ToastState): ToastState => state[featureToastKey];
export const selectInfoToasts = createSelector(getToastsState, (state): ToastModel[] => state.info);
export const selectErrorToasts = createSelector(getToastsState, (state): ToastModel[] => state.error);
export const selectSuccessToasts = createSelector(getToastsState, (state): ToastModel[] => state.success);
export const selectWarningToasts = createSelector(getToastsState, (state): ToastModel[] => state.warning);
